import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'object',
            empty: false,
            mandatory: false,
            attributes: {
                type: {
                    type: 'string',
                    empty: false,
                    mandatory: true
                },
                data: {
                    type: 'object',
                    empty: false,
                    mandatory: true
                },
                container_style: {
                    type: 'object',
                    empty: false,
                    mandatory: false
                },
                config: {
                    type: 'object',
                    empty: false,
                    mandatory: false
                }
            }
        };
    }
}
